<template>
  <div class="filters on-lg">
    <div class="filter-header">
      <h3 class="header">Filters</h3>
      <div class="sorts">
        <i class="fa-solid fa-search"></i>
        <input
          type="text"
          placeholder="Gallery Name"
          v-model="filterData.gallery_name_eng"
        />
      </div>
    </div>
    <div class="filter-categories">
      <div
        class="category-item"
        :class="filterData.selectedCategory == 'All' ? 'active' : ''"
        @click="filterData.selectedCategory = 'All'"
      >
        All
      </div>
      <div
        class="category-item"
        v-for="category in categories"
        :key="category.id"
        :class="filterData.selectedCategory == category ? 'active' : ''"
        @click="filterData.selectedCategory = category"
      >
        {{ category }}
      </div>
    </div>
    <div class="filter-expands">
      <div class="expand-item">
        <div class="top" @click="filters.countries = !filters.countries">
          <i class="fa-solid fa-plus" v-if="!filters.countries"></i>
          <i class="fa-solid fa-minus" v-else></i>
          <p>GALLERY LOCATION</p>
        </div>
        <div class="bottom" :class="filters.countries ? 'active' : ''">
          <input
            type="text"
            placeholder="Search by location"
            v-model="filterData.address_eng"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        sizes: false,
        materials: false,
        orientation: false,
        medium: false,
        color: false,
        year: false,
        prices: false,
        hammer: false,
        uci: false,
        actionDate: false,
        lastUpdate: false,
        location: false,
        countries: false,
      },
      categories: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      filterData: {
        gallery_name_eng: "",
        address_eng: "",
        selectedCategory: "All",
      },
    };
  },
  methods: {},
  watch: {
    filterData: {
      handler() {
        this.$emit("filterData", this.filterData);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>